module.exports = function() {
  return new Worker(__webpack_public_path__ + "190b0e5482e6c2592258.worker.js");
};